const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp']

const FILE_ICON_MAP = {
    pdf: 'file-earmark-pdf',
    doc: 'file-earmark-word',
    docx: 'file-earmark-word',
    xls: 'file-earmark-excel',
    xlsx: 'file-earmark-excel',
    zip: 'file-earmark-zip',
    rar: 'file-earmark-zip',
    txt: 'file-earmark-text',
    csv: 'file-earmark-spreadsheet'
}

export function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return `${Math.round(bytes / Math.pow(k, i) * 100) / 100} ${sizes[i]}`
}

export function getFileExtension(filename) {
    return filename.split('.').pop().toLowerCase()
}

export function isImage(filename) {
    return IMAGE_EXTENSIONS.includes(getFileExtension(filename))
}

export function getFileIcon(filename) {
    return FILE_ICON_MAP[getFileExtension(filename)] ?? 'file-earmark'
}

export function downloadFile(url, filename, toast) {
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    toast?.({
        title: 'Успех',
        message: 'Файл успешно скачен!',
        variant: 'success'
    })
}

export function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
}

export function filenameFromContentDisposition(header) {
    if (!header) return null
    const utf8 = header.match(/filename\*=UTF-8''([^;]+)/i)
    if (utf8) {
        try {
            return decodeURIComponent(utf8[1].trim())
        } catch (e) {
            void e
        }
    }
    const plain = header.match(/filename="?([^";]+)"?/i)
    return plain ? plain[1].trim() : null
}

/**
 * Достаёт текст ошибки из ответа, пришедшего с responseType: 'blob'.
 * Такой ответ не проходит обычный JSON-парсинг axios, поэтому читаем его вручную.
 */
export async function readBlobErrorMessage(blob, fallback = 'Не удалось скачать файл') {
    if (!(blob instanceof Blob)) return fallback
    try {
        const text = await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsText(blob)
        })
        const data = JSON.parse(text)
        if (data?.errors && typeof data.errors === 'object') {
            const messages = Object.values(data.errors).flat().filter(Boolean)
            if (messages.length) return messages.join('\n')
        }
        if (typeof data?.message === 'string' && data.message) return data.message
        return fallback
    } catch (e) {
        void e
        return fallback
    }
}
